import { inject, Injectable } from '@angular/core';
import { LogManagerService } from './LogManager.service';
import { SafeAny } from '@pf/shared-common';

@Injectable({
    providedIn: 'root',
})
export class LoggerService {
    private logManager = inject(LogManagerService);

    trace(message: string) {
        this.logManager.log.trace(message);
    }

    debug(message: string) {
        this.logManager.log.debug(message);
    }

    info(message: string) {
        this.logManager.log.info(message);
    }

    warn(message: string, error?: SafeAny) {
        if (error) {
            this.logManager.log.warn({ error }, message);
        } else {
            this.logManager.log.warn(message);
        }
    }

    error(message: string, error?: SafeAny) {
        if (error) {
            this.logManager.log.error({ error }, message);
        } else {
            this.logManager.log.error(message);
        }
    }

    fatal(message: string, error?: SafeAny) {
        if (error) {
            this.logManager.log.fatal({ error }, message);
        } else {
            this.logManager.log.fatal(message);
        }
    }
}
